import { mockInstance, withDelay } from '../../../../api/axiosInstance.mock';

import { PRESELECTIONNER_OFFRE_END_POINT } from '../../apiEndPoints';
import { dataCoEmprunteur1 as sessionMockData } from '../../contexte/useSessionApi/useSessionApi.mock';

const endPoint = PRESELECTIONNER_OFFRE_END_POINT.replace(
    /{idDemande}/g,
    String(sessionMockData?.contextePret?.idDemande)
)
    .replace(/{idOffre}/g, String('[0-9]+'))
    .replace(/{statutDemande}/g, String('[A-Z_]+'));

export const usePreselectionnerOffreApiMock = (): any => {
    const url = new RegExp(`${endPoint}`);

    mockInstance.onPut(url).reply(
        withDelay(
            [
                200,
                {
                    pageInitiale: 'OFFRE',
                    codeAvis: null
                }
            ],
            200
        )
    );
};
